import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-266">
      <div className="max-w-5xl mx-auto" data-id="element-267">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-268">
          <div data-id="element-269">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-270">
              +500
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-271">
              profes confían
            </div>
          </div>
          <div data-id="element-272">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-273">
              6+6
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-274">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-275">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-276">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-277">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-278">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-279">🇦🇷</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-280">
              Todo el país
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-281">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-282">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-283">
              SM
            </div>
            <div data-id="element-284">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-285">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-286">
                "Organicé todo el año de clases en una tarde. Nunca más llegué
                al salón sin saber exactamente qué dar ni cómo corregir."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-287">
                — Sebastián M., Buenos Aires | Profesor de Tango Particular
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-288">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-289">
              CR
            </div>
            <div data-id="element-290">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-291">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-292">
                "Los guiones de corrección del Tomo 5 me cambiaron la forma de
                enseñar. Antes repetía siempre lo mismo. Ahora tengo 80 guiones
                exactos para cada situación y los alumnos resuelven los errores
                en la misma clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-293">
                — Claudia R., Rosario | Profesora de Tango en Academia
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-294">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-295">
              DP
            </div>
            <div data-id="element-296">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-297">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-298">
                "El sistema de musicalidad del Tomo 3 es lo que ningún otro
                material tiene. Mis alumnos ahora bailan diferente con D'Arienzo
                que con Pugliese. Eso antes era imposible sin teoría musical."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-299">
                — Diego P., Córdoba | Profesor de Tango Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}